// @flow

import * as React from 'react';
import { Environment } from '@ta/lithium.context';

export type ProvidedCdnProps = {|
  imgCdnUrl: string,
|};

type ImageRequirementProps = {|
  src: string,
|};

/**
 * a higher-order function that returns the given Component with props.imgCdnUrl provided.
 * @param Component
 * @returns {*}
 */
const withCDNPrefix = (
  Component: React.ComponentType<Object & ProvidedCdnProps>,
): React.ComponentType<Object> => {
  const ExternalPropsContainer = (externalProps: any) => {
    const { cdnPrefix } = React.useContext(Environment);
    return <Component {...externalProps} imgCdnUrl={cdnPrefix} />;
  };
  return ExternalPropsContainer;
};

const CdnImageInner = (props: Object & ProvidedCdnProps & ImageRequirementProps) => {
  // pull dispatch out, we don't want that in the img tag
  const { imgCdnUrl, src, dispatch, ...rest } = props;
  const sep = /^\//.test(src) ? '' : '/';
  return <img {...rest} src={`${imgCdnUrl}${sep}${src}`} />;
};
/**
 * Use this component like a <img/> component. It will transform the given relative src url and append it with our CDN prefix
 * @type {React.ComponentType<Object>}
 */
export const CdnImage = withCDNPrefix(CdnImageInner);

export default withCDNPrefix;
